import {
    Component,
    ElementRef,
    EventEmitter,
    OnInit,
    Output,
    Renderer2,
    ViewChild,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { SearchService } from '../../../../shared/services/search.search';
import { ActivatedRoute, Router } from '@angular/router';
import { IcdService } from '../../../../shared/services/icd.service';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-search-icd9',
    templateUrl: './search-icd9.component.html',
    styleUrls: ['./search-icd9.component.scss'],
})
export class SearchIcd9Component implements OnInit {
    private unsubscriber = new Subject<void>();
    @Output() messageEvent = new EventEmitter<object>();
    @ViewChild('toggleButton') toggleButton: ElementRef;
    @ViewChild('menu') menu: ElementRef;
    @ViewChild('recommendBox') recommendBox: ElementRef;
    @ViewChild('boxSearch') boxSearch: ElementRef;
    @ViewChild('searchInput') searchInput: ElementRef;
    isSearching = false;
    searchResults: any;
    searchResultsFormat: any;
    sub: Subscription;
    keySearch = new FormControl();
    debouncedValue = '';
    selectedItem: any;
    language: any;
    isShowResult = false;
    url = false;
    previousSearchQuery: string = '';
    searchEnter: string = '';
    enterPressed: boolean = false;
    enterTimeout: any;
    searchTimer: any;

    constructor(
        private searchService: SearchService,
        private route: ActivatedRoute,
        private icdService: IcdService,
        private readonly router: Router,
        private renderer: Renderer2,
        private toastService: ToastrService,
        public translate: TranslateService,
        private el: ElementRef,
    ) {
        this.renderer.listen('window', 'click', (e: Event) => {
            if (
                this.toggleButton &&
                this.menu &&
                e.target !== this.toggleButton.nativeElement &&
                e.target !== this.menu?.nativeElement
            ) {
                this.isShowResult = false;
            }
            if (this.el.nativeElement !== e.target && !this.el.nativeElement.contains(e.target)) {
                this.closeRec();
            }
        });
    }

    ngOnInit(): void {
        this.language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'vi';
        this.url = this.router.url.includes('icd9-dual');
    }
    onSearch() {
        if (!this.debouncedValue.trim()) {
            // Nếu không có giá trị để tìm kiếm, có thể đặt searchResults về null hoặc mảng trống.
            this.searchResults = null;
            this.closeRec();
            return;
        }
        this.isSearching = true;
        this.previousSearchQuery = this.debouncedValue;
        this.searchService.search_ICD9(this.debouncedValue, this.language).subscribe(
            (data: any) => {
                if (data) {
                    this.searchResults = data;
                    this.isShowResult = true;
                    this.isSearching = false;
                    this.openRec();
                }
            },
            (error: any) => {
                this.isSearching = false;
                this.toastService.error(`${error?.message
                }`, 'Thất bại');

            }
        );
    }
    handleDelInput() {
        this.debouncedValue = '';
         this.searchResults = null;
         this.closeRec()
    }
    handleInputChange() {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
            if (this.debouncedValue.trim() !== this.previousSearchQuery) {
                this.onSearch();
            }
        }, 2000);
    }

    handleKeyDown(event: KeyboardEvent) {
        // event.preventDefault();
        if (event.key == 'Enter') {
            this.onSearch();
        }
    }

    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();
        clearTimeout(this.enterTimeout);
    }

    searchItem(event: any) {
        this.closeRec();
        event.preventDefault();
        let href = '';
        let target = event.target || event.srcElement;
        while (target) {
            if (target instanceof HTMLAnchorElement) {
                href = target.getAttribute('href')!; //non-null assertion
                break;
            }
            target = target.parentNode;
        }
        let id = href.split('/')[1];
        let model = href.split('/')[0];
        this.isShowResult = false;
        let language = this.language;
        this.url = this.router.url.includes('icd9-dual');
        if (this.url) language = 'dual';
        this.icdService.getDetailModel_ICD9(model, id, language).subscribe(
            (res) => {
                this.selectedItem = res.data;
                this.messageEvent.emit(this.selectedItem);
            },
            (error) => {
                console.error('Error occurred while fetching details:', error);
                this.toastService.error(`${error?.error.error}`, 'Thất bại');

            }
        );
    }

    focusFunction(): void {
        this.isShowResult = true;
        if (!this.debouncedValue) {
            this.searchResults = null;
        } else {
            let data = localStorage.getItem('searchResults');
            if (data != null) {
                this.searchResults = JSON.parse(data);
            }
        }
    }
    closeRec() {
        if (this.recommendBox && this.recommendBox.nativeElement) {
            this.recommendBox.nativeElement.classList.add('hidden');
        }
    
        if (this.boxSearch && this.boxSearch.nativeElement) {
            this.boxSearch.nativeElement.classList.remove('bar-data');
            this.boxSearch.nativeElement.classList.add('bar-1');
        }
        if (this.searchInput && this.searchInput.nativeElement) {
            this.searchInput.nativeElement.classList.remove('searchbar-data');
            this.searchInput.nativeElement.classList.add('searchbar');
        }
    }
    handleOpen(){

        if(this.searchResults){
            this.openRec();
            this.isShowResult=true
         
        }
    }
    openRec() {
        if (this.recommendBox && this.recommendBox.nativeElement) {
            this.recommendBox.nativeElement.classList.remove('hidden');
            this
        }
    
        if (this.boxSearch && this.boxSearch.nativeElement) {
            this.boxSearch.nativeElement.classList.add('bar-data');
            this.boxSearch.nativeElement.classList.remove('bar-1');
        }
        if (this.searchInput && this.searchInput.nativeElement) {
            this.searchInput.nativeElement.classList.add('searchbar-data');
            this.searchInput.nativeElement.classList.remove('searchbar');
        }
    }
}
